const SERVICES_COLOR = {
  'Open innovation': '#33DFFF',
  'Funding': '#1832AB',
  'Sales': '#F25018'
};

export default serviceName => SERVICES_COLOR[serviceName] || '#181818';
